import { getGpuPowerUsage } from '@/features/monitoring/api/prometheusApi';

import { createGpuMetricHook } from './createGpuMetricHook';

/**
 * GPU 전력 사용량 조회 Hook
 */
export const useGpuPowerUsage = createGpuMetricHook('gpu-power-usage', getGpuPowerUsage);
